// Imports
import axios from 'axios';

// App imports
import { URL_API } from '../../../../../setup/config/env';

// Persist Progress Report schedule/assignee changes to GitLab.
export default function updateIssue({
  projectId,
  issueIid,
  refreshToken,
  dueDate,
  assigneeId,
}) {
  const body = {
    token: refreshToken,
    projectId,
    issueIid,
  };

  if (dueDate !== undefined) {
    body.due_date = dueDate;
  }
  if (assigneeId !== undefined) {
    body.assignee_id = assigneeId;
  }

  return axios.put(`${URL_API}/gitlab/updateIssue`, body);
}
